import React from 'react';
import { makeStyles, createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const CustomButtonOLDailyBlue = (props) => {
  const customTheme = theme => ({
    root: {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'none',
      color: '#ffffff',
//      color: theme.palette.getContrastText(props.themeColor[50]),
      backgroundColor: '#00b3cd',
      transition: '.3s',
      '&:hover': {
        borderColor: '#00b3cd',
        color: '#00b3cd',
        backgroundColor: 'transparent',
        opacity: '85%',
      },
    },
  })
  const ComponentName = withStyles(customTheme)(Button)
  return <ComponentName {...props} />
}
export default CustomButtonOLDailyBlue;
